import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { Crown, Loader2 } from "lucide-react";

export default function ProSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("polling");
  useEffect(() => {
    let n = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/subscriptions/status/${params.get("session_id")}`);
        if (r.data.pro) return setState("ok");
      } catch {}
      if (++n < 10) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
  }, [params]);
  return (
    <div>
      <Navbar />
      <div className="max-w-xl mx-auto px-6 py-20 text-center" data-testid={`pro-${state}`}>
        <div className="grid place-items-center">{state === "polling" ? <Loader2 className="w-12 h-12 animate-spin text-slate-500" /> : <Crown className="w-12 h-12 text-amber-500" />}</div>
        <h1 className="mt-6 text-3xl font-extrabold text-slate-900">{state === "polling" ? "Activation de Coach Pro…" : state === "ok" ? "Bienvenue chez Coach Pro !" : "Activation en cours"}</h1>
        <p className="mt-3 text-slate-600">{state === "ok" ? "Accès prioritaire aux créneaux de dernière minute et 0 € de frais de service dès maintenant." : "Votre abonnement sera actif d'ici quelques instants."}</p>
        <Link data-testid="pro-back-dashboard" to="/tableau-de-bord" className="mt-8 inline-flex sc-btn sc-btn-primary">Retour au tableau de bord</Link>
      </div>
      <Footer />
    </div>
  );
}
